import { useSelector } from "react-redux";
import { selectCurrentLogbook } from "../../store/features/logbooks.slice";
import EditLogbook from "../common/edit-logbook";

export default function EditCompanyLogbook() {
  const logbook = useSelector(selectCurrentLogbook);

  return <EditLogbook logbook={logbook} />;
}
